import React from 'react';

import { AngularDirective } from '../../../common/react/components/AngularDirective';
import { ReactDirectiveProps } from '../../../ts/directives/reactDirectiveFactory';

const template = `<div ng-controller="AddSiteCtrl" ng-include="'addSite.html'"></div>`;

export interface AddSiteSettingsSubspaceProps extends ReactDirectiveProps {}

export function AddSiteSettingsSubspace(props: AddSiteSettingsSubspaceProps) {
  return (
    <div className={'tb-stylish-settings'}>
      <AngularDirective
        angularContext={props.angularContext}
        template={template}
      />
    </div>
  );
}
